import { useState } from 'react';
import {
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Box,
  Alert
} from '@mui/material';

import axios from 'axios';

export default function ChangePassword() {

  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const SERVER_URL = process.env.REACT_APP_AUTHENTICATION_BACKEND_SERVER_URL;

  const handleSubmit = async () => {
    setError('');
    setSuccess('');

    if (!oldPassword || !newPassword || !confirmPassword) {
      setError('All fields are required');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const token = user?.accessToken;

      if (!token) {
        setError('User not authenticated');
        return;
      }

      await axios.post(
        `${SERVER_URL}/api/auth/change-password`,
        {
          oldPassword,
          newPassword
        },
        {
          headers: {
            "x-access-token": token
          }
        }
      );

      setSuccess('Password changed successfully. Redirecting to login...');

      setTimeout(() => {
        localStorage.removeItem("user");
        window.location.href = "/login";
      }, 1000);

    } catch (err) {
      setError(err.response?.data?.message || 'Error changing password');
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#001536'
      }}
    >
      <Card
        sx={{
          width: 420,
          backgroundColor: '#00122E',
          color: '#fff',
          border: '1px solid #3949ab33',
          borderRadius: 3,
          boxShadow: '0 6px 25px rgba(0,0,0,0.6)',
          backdropFilter: 'blur(6px)'
        }}
      >
        <CardContent>

          <Typography
            variant="h6"
            sx={{
              mb: 2,
              fontWeight: 600,
              color: '#e2e8f0'
            }}
          >
            Change Password
          </Typography>

          {error && (
            <Alert
              severity="error"
              sx={{
                mb: 2,
                backgroundColor: '#dc2626',
                color: '#fff'
              }}
            >
              {error}
            </Alert>
          )}

          {success && (
            <Alert
              severity="success"
              sx={{
                mb: 2,
                backgroundColor: '#16a34a',
                color: '#fff'
              }}
            >
              {success}
            </Alert>
          )}

          <TextField
            label="Old Password"
            type="password"
            fullWidth
            margin="normal"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            InputLabelProps={{ style: { color: '#94a3b8' } }}
            sx={{
              input: { color: '#fff' },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: '#3949ab33'
                },
                '&:hover fieldset': {
                  borderColor: '#3949ab'
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#facc15'
                }
              }
            }}
          />

          <TextField
            label="New Password"
            type="password"
            fullWidth
            margin="normal"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            InputLabelProps={{ style: { color: '#94a3b8' } }}
            sx={{
              input: { color: '#fff' },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: '#3949ab33'
                },
                '&:hover fieldset': {
                  borderColor: '#3949ab'
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#facc15'
                }
              }
            }}
          />

          <TextField
            label="Confirm Password"
            type="password"
            fullWidth
            margin="normal"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            InputLabelProps={{ style: { color: '#94a3b8' } }}
            sx={{
              input: { color: '#fff' },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: '#3949ab33'
                },
                '&:hover fieldset': {
                  borderColor: '#3949ab'
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#facc15'
                }
              }
            }}
          />

          <Button
            fullWidth
            sx={{
              mt: 2,
              backgroundColor: '#001B44',
              color: '#fff',
              border: '1px solid #3949ab',
              borderRadius: 2,
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: '#001B44',
                boxShadow: '0 0 10px rgba(250,204,21,0.5)',
                borderColor: '#facc15'
              },
              '&:disabled': {
                backgroundColor: '#1e293b',
                color: '#6b7280'
              }
            }}
            onClick={handleSubmit}
            disabled={!oldPassword || !newPassword || !confirmPassword}
          >
            Save
          </Button>

        </CardContent>
      </Card>
    </Box>
  );
}